/**
 * PlaceCoreFactsCard — "Bra att veta" with fact rows.
 * Uses factsRows from getPlacePresentation (Område → Kommun → Landskap → Län).
 */
import { MapPin } from "lucide-react";
import { useTranslate } from "@/i18n";

interface Props {
  factsRows: { label: string; value: string }[];
}

export function PlaceCoreFactsCard({ factsRows }: Props) {
  const t = useTranslate();
  if (factsRows.length === 0) return null;

  return (
    <div className="rounded-xl border border-border/40 bg-card p-4 sm:p-5">
      <div className="flex items-center gap-2 mb-3">
        <MapPin className="h-3.5 w-3.5 text-muted-foreground/60" />
        <span className="text-xs font-medium text-muted-foreground uppercase tracking-wider">{t("place.facts.heading")}</span>
      </div>
      <div className="space-y-2.5">
        {factsRows.map((row) => (
          <div key={row.label} className="flex items-baseline justify-between gap-4">
            <span className="text-xs text-muted-foreground uppercase tracking-wide shrink-0">
              {t(row.label)}
            </span>
            <span className="text-sm text-foreground font-medium text-right">
              {row.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
